import React, { useEffect } from 'react'
import GHref from 'tennders-market/common/components/element/GHref'
import TextInput from 'tennders-common/form/components/new-inputs/TextInput'
import CurrencyInput from 'tennders-common/form/components/new-inputs/CurrencyInput'
import { GInput } from 'tennders-common/form/components'
import GCurrency from 'tennders-market/common/components/element/GCurrency'
import TransactionSelectInput from 'tennders-finance/cost-invoice/components/TransactionSelectInput'
import useMultipleCostInvoiceExtraCostRow from 'tennders-finance/cost-invoice/hooks/useMultipleCostInvoiceExtraCostRow'
import PercentageInput from 'tennders-common/form/components/new-inputs/PercentageInput'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

const MultipleCostInvoiceExtraCostRow = ({
  index = 0,
  removeLine,
  onFormChange,
  initialErrors,
  companyId,
  keyIndex,
  editMode,
  reversedVat,
  defaultVat
}) => {
  const { onChange, errors, form, transaction, onTransactionChange } = useMultipleCostInvoiceExtraCostRow({ initialErrors, index })

  useEffect(() => {
    if (onFormChange) {
      onFormChange(index, form)
    }
  }, [onFormChange, index, form])

  useEffect(() => {
    if (!editMode) {
      onChange('vatPercentage', defaultVat)
    }
  }, [defaultVat])

  return (
    <tr>
      <td>
        <GHref
          className="cursor-pointer link-mid-gray"
          onClick={() => removeLine(keyIndex)}
        >
          <FontAwesomeIcon icon={faXmark} fontSize={20} />
        </GHref>
      </td>
      <td>
        {index + 1}
      </td>
      <td>
        <TransactionSelectInput
          withAll
          companyType="carrier"
          companyId={companyId}
          transactionId={form.transactionId}
          selectedOptionLabel={transaction?.referenceNumber}
          error={errors?.transactionId}
          disabled={!companyId}
          onTransactionChange={onTransactionChange}
        />
      </td>
      <td>
        <TextInput
          className="form-input smaller"
          value={form.concept}
          error={errors.concept}
          onSet={(value) => onChange('concept', value)}
        />
      </td>
      <td>
        <CurrencyInput
          allowNegativeValue={false}
          className="form-input smaller"
          placeholder="amount"
          onSet={(value) => onChange('amount', value)}
          value={form.amount}
          error={errors.amount}
        />
      </td>
      <td>
        <PercentageInput
          className="form-input smaller"
          onSet={(value) => onChange('vatPercentage', value)}
          name="vatPercentage"
          placeholder="0%"
          value={form.vatPercentage || 0}
          error={errors.vatPercentage}
        />
      </td>
      <td>
        {GCurrency({ value: form.totalAmount || 0 })}
      </td>
    </tr>
  )
}

export default MultipleCostInvoiceExtraCostRow
